import { Link, Navigate, useParams } from 'react-router-dom'
import PageHero from '../components/PageHero'
import { getSolutionBySlug } from '../content/solutionsContent'

export default function SolutionDetailPage() {
  const { slug } = useParams()
  const solution = getSolutionBySlug(slug)

  if (!solution) {
    return <Navigate to="/solutions" replace />
  }

  return (
    <div className="page">
      <PageHero
        eyebrow="Solutions"
        title={solution.title}
        lead={solution.hero}
        image={solution.image}
        imageAlt={solution.title}
        imagePosition={solution.imagePosition || 'center center'}
      />

      <section className="page-section">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 page-prose">
          <p>{solution.intro}</p>
        </div>
      </section>

      {solution.sections.map((section) => (
        <section
          key={section.title}
          className={`page-section${solution.sections.indexOf(section) % 2 ? ' page-section--alt' : ''}`}
        >
          <div className="mx-auto max-w-4xl px-4 sm:px-6">
            <h2 className="page-section__title">{section.title}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph.slice(0, 24)} className="page-section__lead">{paragraph}</p>
            ))}
            {section.bullets && (
              <ul className="page-list">
                {section.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            )}
          </div>
        </section>
      ))}

      <section className="page-section page-section--cta">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 text-center">
          <h2 className="page-section__title">Request a Quote</h2>
          <p className="page-section__lead">
            Contact our team to discuss a program tailored to your facility.
          </p>
          <Link to="/contact" className="page-cta-button">
            Contact Us <span aria-hidden="true">&gt;</span>
          </Link>
        </div>
      </section>
    </div>
  )
}
